import { createReducer } from "redux-act";
import actions from "../actions/notificationActions";
import appConstants from '../../../utils/Constants.config';
import { ca } from "date-fns/locale";

const initialState = {
  isOpen: false,
  isDialogOpen: false,
  messageText: '',
  dialogText: '',
  dialogBtnText: '',
  duration: 0, // In milliseconds
  isOpenSnackbar: false,
  alertType: 'success',


  getNotificationPending: false,
  getNotificationRes: null,
  getNotificationError: null,

  deleteNotificationPending: false,
  deleteNotificationRes: null,
  deleteNotificationError: null,

  updateNotificationPending: false,
  updateNotificationRes: null,
  updateNotificationError: null,


  deleteAllNotificationPending: false,
  deleteAllNotificationRes: null,
  deleteAllNotificationError: null,
};

const handleOpen = (state, action, position = undefined) => ({
  ...state,
  messageText: action,
  isOpen: true,
  duration: 0,
  position,
});

const handleOpenWithDuration = (state, payload) => ({
  ...state,
  messageText: payload.text,
  isOpen: true,
  duration: parseInt(payload?.duration || appConstants.defaultAlertDuration, 10),
  position: payload.position ? payload.position : undefined,
});

const handleClose = state => ({
  ...state,
  isOpen: false,
  messageText: '',
  duration: 0,
});

const handleOpenDialog = (state, payload) => ({
  ...state,
  isDialogOpen: true,
  dialogText: payload.dialogText,
  dialogBtnText: payload.dialogBtnText,
  isForceUpdate: payload.isForceUpdate || false,
});

const handleCloseDialog = state => ({
  ...state,
  isDialogOpen: false,
  isForceUpdate: false,
  dialogText: '',
  dialogBtnText: '',
});

const handleOpenSnackbar = (state, payload) => ({
  ...state,
  messageText: payload.text,
  alertType: payload.alertType,
  isOpenSnackbar: true,
  duration: parseInt(payload?.duration || appConstants.defaultAlertDuration, 10),
  position: payload.position ? payload.position : undefined,
});

const handleCloseSnackbar = state => ({
  ...state,
  isOpenSnackbar: false,
  messageText: '',
  alertType: '',
  duration: 0,
});


/* Get Notification Reducers */
const handleGetNotificationRequest = state => {
  return {
    ...state,
    ...{
      getNotificationPending: true,
      getNotificationRes: null,
      getNotificationError: null,
    },
  };
};
const handleGetNotificationSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getNotificationPending: false,
      getNotificationRes: payload,
      getNotificationError: null,
    },
  };
};
const handleGetNotificationError = (state, payload) => ({
  ...state,
  ...{
    getNotificationPending: false,
    getNotificationRes: null,
    getNotificationError: payload,
  },
});


/* Delete Notification Reducers */
const handleDeleteNotificationRequest = state1 => {
  return {
    ...state1,
    ...{
      deleteNotificationPending: true,
      deleteNotificationRes: null,
      deleteNotificationError: null,
    },
  };
};
const handleDeleteNotificationSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      deleteNotificationPending: false,
      deleteNotificationRes: payload,
      deleteNotificationError: null,
    },
  };
};
const handleDeleteNotificationError = (state1, payload) => ({
  ...state1,
  ...{
    deleteNotificationPending: false,
    deleteNotificationRes: null,
    deleteNotificationError: payload,
  },
});

/* Update Notification Reducers */
const handleUpdateNotificationRequest = state1 => {
  return {
    ...state1,
    ...{
      updateNotificationPending: true,
      updateNotificationRes: null,
      updateNotificationError: null,
    },
  };
};
const handleUpdateNotificationSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateNotificationPending: false,
      updateNotificationRes: payload,
      updateNotificationError: null,
    },
  };
};
const handleUpdateNotificationError = (state1, payload) => ({
  ...state1,
  ...{
    updateNotificationPending: false,
    updateNotificationRes: null,
    updateNotificationError: payload,
  },
});

/* Delete All Notification Reducers */
const handleDeleteAllNotificationRequest = state1 => {
  return {
    ...state1,
    ...{
      deleteAllNotificationPending: true,
      deleteAllNotificationRes: null,
      deleteAllNotificationError: null,
    },
  };
};
const handleDeleteAllNotificationSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      deleteAllNotificationPending: false,
      deleteAllNotificationRes: payload,
      deleteAllNotificationError: null,
    },
  };
};
const handleDeleteAllNotificationError = (state1, payload) => ({
  ...state1,
  ...{
    deleteAllNotificationPending: false,
    deleteAllNotificationRes: null,
    deleteAllNotificationError: payload,
  },
});

// Clear Leave Store Reducers */
const clearNotificationStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_DELETE_NOTIFICATION_STORE':
      return {
        ...state,
        ...{
          deleteNotificationPending: false,
          deleteNotificationRes: null,
          deleteNotificationError: null,
        },
      };

    case 'HANDLE_CLEAR_UPDATE_NOTIFICATION_STORE':
      return {
        ...state,
        ...{
          updateNotificationPending: false,
          updateNotificationRes: null,
          updateNotificationError: null,
        },
      };
      case 'HANDLE_CLEAR_DELETE_ALL_NOTIFICATION_STORE':
        return {
          ...state,
          ...{
            deleteAllNotificationPending: false,
            deleteAllNotificationRes: null,
            deleteAllNotificationError: null,
          },
        };

    default:
      return state;
  }
};


export default createReducer({
  [actions.openMessageModal]: handleOpen,
  [actions.openMessageModalDuration]: handleOpenWithDuration,
  [actions.closeMessageModal]: handleClose,
  [actions.openDialog]: handleOpenDialog,
  [actions.closeDialog]: handleCloseDialog,
  [actions.openSnackbar]: handleOpenSnackbar,
  [actions.closeSnackbar]: handleCloseSnackbar,

  [actions.getNotificationRequest]: handleGetNotificationRequest,
  [actions.getNotificationSuccess]: handleGetNotificationSuccess,
  [actions.getNotificationError]: handleGetNotificationError,

  [actions.deleteNotificationRequest]: handleDeleteNotificationRequest,
  [actions.deleteNotificationSuccess]: handleDeleteNotificationSuccess,
  [actions.deleteNotificationError]: handleDeleteNotificationError,

  [actions.updateNotificationRequest]: handleUpdateNotificationRequest,
  [actions.updateNotificationSuccess]: handleUpdateNotificationSuccess,
  [actions.updateNotificationError]: handleUpdateNotificationError,

  [actions.deleteAllNotificationRequest]: handleDeleteAllNotificationRequest,
  [actions.deleteAllNotificationSuccess]: handleDeleteAllNotificationSuccess,
  [actions.deleteAllNotificationError]: handleDeleteAllNotificationError,

  [actions.clearNotification]: clearNotificationStore,
},
  initialState
);
